import { useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'

import { ContactMetadata, ContactMetadataResponse } from '../types/contact'

type ContactMetadataRequest = {
  companyId: number
  contactId: number
  isContactCreateFromRelationships: boolean
}

export const emptyMetadata: ContactMetadata = {
  companyId: 0,
  contactId: 0,
  debtAmount: 0,
  debtMaturityDate: '',
  debtMonthlyPayment: 0,
  debtPaymentFrequency: '',
  isAccountSigner: false,
  isDebtholder: false,
  isDocuments: false,
  isFinancials: false,
  isOwner: false,
  ownershipPercent: '0',
  ownershipAmount: 0,
  title: '',
  permissions: []
}

const request = (opts?: ContactMetadataRequest) =>
  opts?.contactId && !opts?.isContactCreateFromRelationships
    ? Request.post(Request.urls.bank.contactCompanyConnectionEditMode, opts)
    : Request.post(Request.urls.bank.contactCompanyConnectionCreateMode, opts)

export const useContactMetadataItem = (opts: ContactMetadataRequest) =>
  useQuery<ContactMetadataRequest, Error, ContactMetadataResponse>({
    queryFn: () => request(opts),
    queryKey: ['company-connection-edit-mode', opts]
  })
